<template>
    <div class="profile-page">
        <section class="section-profile-cover section-shaped my-0">
            <div class="shape shape-style-1 shape-primary shape-skew alpha-4">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
        </section>
        <section class="section section-skew">
            <div class="container">
                <card shadow class="card-profile mt--300" no-body>
                    <div class="px-4">
                        <div class="row justify-content-center">
                            <div class="col-lg-3 order-lg-2">
                                <div class="card-profile-image">
                                    <a href="#">
                                        <img v-lazy="data.img" class="rounded-circle">
                                    </a>
                                </div>
                            </div>
                            <div class="col-lg-4 order-lg-3 text-lg-right align-self-lg-center">
                                <div class="card-profile-actions py-4 mt-lg-0">
                                    <base-button tag="a" :href="data.twitter" target="_blank" type="info" size="sm" class="mr-4">
                                        <font-awesome-icon :icon="['fab', 'twitter']" size="lg"></font-awesome-icon> Connect
                                    </base-button>
                                </div>
                            </div>
                            <div class="col-lg-4 order-lg-1">
                                <div class="card-profile-stats d-flex justify-content-center">
                                    <div v-for="stat in data.stats">
                                        <span class="heading">{{ stat.value }}</span>
                                        <span class="description">{{ stat.title }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="text-center mt-5">
                            <h3>{{ data.name }}
                                <span class="font-weight-light"> </span>
                            </h3>
                            <div class="h6 font-weight-300"><font-awesome-icon icon="location-arrow"></font-awesome-icon> {{ data.location }}</div>
                            <div class="h6 mt-4"><font-awesome-icon icon="briefcase"></font-awesome-icon> {{ data.occupation }}</div>
                            <div><font-awesome-icon icon="graduation-cap"></font-awesome-icon> {{ data.degree }}</div>
                        </div>
                        <div class="mt-5 py-5 border-top text-center">
                            <div class="row justify-content-center">
                                <div class="col-lg-9">
                                    <p v-html="data.about"></p>
                                    <!--<a href="#">Show more</a>-->
                                </div>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
        </section>
    </div>
</template>
<script>
export default {
  data: () => ({
    data: require('../../public/details/profile'),
  }),
}
</script>
<style>
</style>
